import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/firebaseConfig";

const getAvailability = httpsCallable(functions, "getSportAvailability");

export async function fetchSportAvailability() {
  const result = await getAvailability();
  return result.data?.sports || {};
}
